import { createStore, applyMiddleware} from "redux";
import thunk from 'redux-thunk';
import reducer from "../reducers/index";
import { routerMiddleware } from 'react-router-redux';

export default function configureStore(initialState, browserHistory) {
    return createStore(reducer, initialState, applyMiddleware(thunk, routerMiddleware(browserHistory)));
}

